/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Pace_HintInputs */

const en_ui_onboarding_pace_hint = /** @type {(inputs: Ui_Onboarding_Pace_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pace zones and efforts for runs`)
};

const de_ui_onboarding_pace_hint = /** @type {(inputs: Ui_Onboarding_Pace_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempozonen und Belastungen bei Läufen`)
};

/**
* | output |
* | --- |
* | "Pace zones and efforts for runs" |
*
* @param {Ui_Onboarding_Pace_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_pace_hint = /** @type {((inputs?: Ui_Onboarding_Pace_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Pace_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_pace_hint(inputs)
	return de_ui_onboarding_pace_hint(inputs)
});